/**
 * JCTCTAS-152: standalone Vite entry for modules/recommended-events-
 * reorder.js -- split out of common.js. Unlike every sibling entry in
 * `entries/`, this one is ONLY meaningful inside the block editor's own
 * preview canvas (`.js-recommended-slides-wrapper` is admin drag-reorder
 * UI, never rendered/interactive on the live front end) -- so
 * inc/scripts.php's jctc_recommended_events_reorder_script() enqueues it on
 * `enqueue_block_assets` (fires in both the editor canvas and the front
 * end) rather than `wp_enqueue_scripts` alone. Loading it on the front end
 * too is harmless: attachAll() below simply finds zero matching wrappers
 * there. See entries/hero-video-viewport.js's own doc comment for why no
 * `$(document).ready()` wrapper is needed.
 */
import initRecommendedEventsReorder from '../modules/recommended-events-reorder.js';

document.addEventListener('DOMContentLoaded', initRecommendedEventsReorder);
